import { RemoveFromBlacklistDto } from '../../../dto/removefromblacklist/removefromblacklistdto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface RemoveFromBlacklistRequest extends APIRequest
{
    getRemoveFromBlacklistRequest(): RemoveFromBlacklistDto;
}

export class RemoveFromBlacklistRequestImpl extends APIRequestDtoImpl implements RemoveFromBlacklistRequest
{
    constructor(private removeFromBlacklistData: RemoveFromBlacklistDto)
    {
        super();
    }

    getRemoveFromBlacklistRequest(): RemoveFromBlacklistDto
    {
        return this.removeFromBlacklistData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/blacklist/removefromblacklist/removefromblacklistrequest.tsx